import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const authService = {

    login: async (data) => {
        return apiRequest({
            method: "POST",
            url: `/api/user/login`,
            data: data
        });
    },

    userList: async (data) => {
        const token = selectAuthToken(store.getState())
        const search = data?.search ? data.search : ''
        const role = data?.role ? data.role : ''
        const vessel = data?.vessel ? data.vessel : ''
        const size = data?.size ? data.size : 25
        const page = data?.page ? data.page : 0
        return apiRequest({
            method: "GET",
            url: `/api/user/all?search=${search}&role=${role}&vessel=${vessel}&size=${size}&page=${page}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    createUser: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "POST",
            url: `/api/user`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    updateUser: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "PUT",
            url: `/api/user`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    viewUser: async (id) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/user/view/${id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    changePassword: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "PATCH",
            url: `/api/user/change_password`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    deleteUser: async (id) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "DELETE",
            url: `/api/user/${id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    }

};

export default authService;